import { Stack } from '@zorro/web/design-system';
import { useState } from 'react';

import {
  EmployeePageContent,
  EmployeePageTabType,
} from './EmployeePageContent';
import {
  EmployeePageActionsOverlays,
  EmployeePageHeader,
  EnrollmentAction,
} from './EmployeePageHeader';

const EMPLOYEE_PAGE_MAX_WIDTH = '94.375rem';

type Props = {
  tab: EmployeePageTabType;
  onboardingPeriodId: string;
  employerId: string;
  employeeId: string;
  isDon?: boolean;
};

export const EmployeePage = ({
  tab,
  onboardingPeriodId,
  employerId,
  employeeId,
  isDon = false,
}: Props) => {
  const [enrollmentTabAction, setEnrollmentTabAction] =
    useState<EnrollmentAction>();

  return (
    <Stack maw={EMPLOYEE_PAGE_MAX_WIDTH} w="100%" mx="auto">
      <EmployeePageHeader
        onEnrollmentTabActionChange={setEnrollmentTabAction}
        onboardingPeriodId={onboardingPeriodId}
        employerId={employerId}
        employeeId={employeeId}
        isDon={isDon}
      />
      <EmployeePageContent
        onEnrollmentTabActionChange={setEnrollmentTabAction}
        onboardingPeriodId={onboardingPeriodId}
        employerId={employerId}
        employeeId={employeeId}
        isDon={isDon}
        tab={tab}
      />
      <EmployeePageActionsOverlays
        onClose={() => setEnrollmentTabAction(undefined)}
        action={enrollmentTabAction}
        onboardingPeriodId={onboardingPeriodId}
        employerId={employerId}
        employeeId={employeeId}
        isDon={isDon}
        tab={tab}
      />
    </Stack>
  );
};
